import { render } from "./LoginButton.vue?vue&type=template&id=45cf4859&scoped=true&ts=true"
import script from "./LoginButton.vue?vue&type=script&lang=ts"
export * from "./LoginButton.vue?vue&type=script&lang=ts"

import "./LoginButton.vue?vue&type=style&index=0&id=45cf4859&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cf4859"]])

export default __exports__